import React, { useState, useEffect } from 'react';
import { formatCNPJ } from '../utils/formaters';
import './CNPJInput.css';

const CNPJInput = ({ value = '', onChange, placeholder = '00.000.000/0000-00', required = false, id }) => {
  const [cnpj, setCnpj] = useState('');

  useEffect(() => {
    // Inicializar com valor formatado se houver
    if (value) {
      const formatted = formatCNPJ(value);
      setCnpj(formatted);
    }
  }, []);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Permitir apenas números
    const numbersOnly = inputValue.replace(/\D/g, '');
    // Limitar a 14 dígitos
    const limitedNumbers = numbersOnly.slice(0, 14);
    const formatted = formatCNPJ(limitedNumbers);

    setCnpj(formatted);

    // Callback com valor completo (apenas números para o form)
    if (onChange) {
      onChange({ target: { value: limitedNumbers } });
    }
  };

  return (
    <input
      id={id}
      type="text"
      className="cnpj-input"
      value={cnpj}
      onChange={handleChange}
      placeholder={placeholder}
      required={required}
      maxLength={18}
    />
  );
};

export default CNPJInput;
